<div class="modal-container">
  <div class="modal-top">
    <div>
      <div class="annons-label">ANNONS</div>
      <h2 mat-dialog-title>Förnya ditt recept hos Doktor.se</h2>
    </div>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div mat-dialog-content>
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header *ngIf="isMobile">
          <mat-panel-title> Ladda ner appen Doktor.se</mat-panel-title>
        </mat-expansion-panel-header>

        <form [formGroup]="receptForm">
          <div *ngIf="isError" class="row">
            <div class="col">
              <div class="alert-danger">
                Det gick inte att skicka data. Försök igen senare.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p>
                Ladda ner appen Doktor.se och förnya ditt recept enkelt i
                mobilen. Fyll i ditt mobilnummer så skickar vi en SMS-länk för
                nedladdning. Appen finns för både iOS och Android.
              </p>
              <mat-form-field class="full-width">
                <input
                  formControlName="phoneNumber"
                  matInput
                  placeholder="Mobilnummer (07XXXXXXXX)"
                >
                <mat-error
                  *ngIf="receptForm.controls.phoneNumber.hasError('required')"
                >
                  Mobilnummer <strong>krävs</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <app-ui-button
                (onClick)="saveQuestion()"
                [color]="'primary'"
                [compressed]="false"
                [expanded]="'block'"
                [size]="'lg'"
              >
                Skicka
              </app-ui-button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="isMobile">
        <mat-expansion-panel-header>
          <mat-panel-title> Jag har redan appen!</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row">
          <div class="col-12">
            <hr>
            <p>Klicka på knappen för att öppna appen Doktor.se på din mobil.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <app-ui-button
              [color]="'primary'"
              [compressed]="false"
              [eventAction]="'klick öppna'"
              [eventCategory]="'RECEPT MODAL Doktor.se - July 2019'"
              [eventParams]="{
                callToAction: 'RECEPT MODAL Doktor.se - July 2019 - klick öppna', pageType: DLPageTypeEnum.OTHER_PAGE
              }"
              [expanded]="'block'"
              [linkUrl]="'https://doktorse.onelink.me/FMEU/receptfornyelse'"
              [size]="'lg'"
              appGtmEvent
              appGtmGa4Event
              title="Doktor.se öppna"
            >
              ÖPPNA
            </app-ui-button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
